/** Lower-case hex SHA-256 of `bytes` (Web Crypto — available in every supported browser). */
export async function sha256Hex(bytes: ArrayBuffer | Uint8Array<ArrayBuffer>): Promise<string> {
  // A view, not the bare buffer: some runtimes (jsdom over Node) reject an
  // ArrayBuffer that a `Response` produced in another realm.
  const view = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes)
  const digest = await crypto.subtle.digest('SHA-256', view)
  return Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, '0')).join('')
}
